// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"0e80a0ad703e9311d41c","532":"2df9d2276bd04872bed9","678":"fe090af0cc047de8e9c6","883":"baf631f0c81064f6a0d9"}[chunkId] + ".js";
};